// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dm-2";
export var aiChatCartContainerExit = "_dm-4";
export var aiChatContainerLarge = "_dm-0";
export var aiChatContainerSmall = "_dm-1";
export var aiChatIcon = "_dm-6";
export var slideInFromRight = "_dm-3";
export var slideOutToRight = "_dm-5";